import { motion } from "framer-motion";
import {
  Factory,
  Truck,
  Banknote,
  Zap,
  Megaphone,
  Camera,
} from "lucide-react";

const INDUSTRIES = [
  { icon: Factory, label: "Manufacturing" },
  { icon: Truck, label: "Logistics & Supply Chain" },
  { icon: Banknote, label: "Finance & Fintech" },
  { icon: Zap, label: "Energy & Utilities" },
  { icon: Camera, label: "Content & Media Creators" },
  { icon: Megaphone, label: "Social Media" },
];

const Industries = () => {
  return (
    <section id="industries" data-testid="industries-section" className="section-pad relative border-t border-[rgba(244,234,222,0.08)]">
      <div className="container-narrow">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.45 }}
            className="lg:col-span-5"
          >
            <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#E94B4B]">
              — Where we operate
            </div>
            <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#F4EADE]">
              Industries we power.
            </h2>
            <p className="mt-4 text-base sm:text-lg text-[#EFE3D6]/75 leading-relaxed">
              We work across competitive industries where commerce, data, intermediation
              and integrations have to be right — the first time.
            </p>

            <div className="mt-8 relative rounded-2xl border border-[rgba(244,234,222,0.12)] bg-[rgba(17,16,21,0.65)] p-6">
              <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#B9AFA6]">
                Operating model
              </div>
              <p className="mt-2 font-display text-lg sm:text-xl text-[#F4EADE] leading-snug">
                Senior delivery teams. Global timezones. One accountable partner from
                discovery to scale.
              </p>
              <div className="mt-5 flex items-center gap-3">
                <div className="h-1 w-12 bg-[#E94B4B]" />
                <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#B9AFA6]">
                  Delivered with force
                </span>
              </div>
            </div>
          </motion.div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4">
              {INDUSTRIES.map((it, i) => {
                const Icon = it.icon;
                return (
                  <motion.div
                    key={it.label}
                    data-testid={`industry-card-${it.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                    initial={{ opacity: 0, y: 14 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.2 }}
                    transition={{ duration: 0.4, delay: i * 0.04 }}
                    className="group flex items-center gap-3 rounded-xl border border-[rgba(244,234,222,0.12)] bg-[rgba(17,16,21,0.7)] p-4 sm:p-5 hover:border-[#E94B4B]/40 hover:bg-[rgba(233,75,75,0.04)] transition-colors"
                  >
                    <div className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-[#6B1F47]/20 ring-1 ring-[#6B1F47]/40 text-[#F4EADE] group-hover:text-[#E94B4B] transition-colors">
                      <Icon className="h-4 w-4" />
                    </div>
                    <span className="font-display text-sm sm:text-base font-semibold text-[#F4EADE]">
                      {it.label}
                    </span>
                  </motion.div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Industries;
